import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { Spin, message } from 'antd';
import { getMontonioPaymentMethods } from '../../http/payments';
import classes from './BankSelection.module.scss';

const BankSelection = ({ onBankSelect, selectedBank }) => {
  const { t, i18n } = useTranslation();
  const [banks, setBanks] = useState([]);
  const [loading, setLoading] = useState(false);
  const [country, setCountry] = useState('');

  useEffect(() => {
    fetchPaymentMethods();
  }, []);

  const fetchPaymentMethods = async () => {
    setLoading(true);
    try {
      const response = await getMontonioPaymentMethods();
      console.log('API response:', response);
      
      if (response.data) {
        setBanks(response.data);
        // Get country from API response
        if (response.country) {
          setCountry(response.country);
          console.log('Country set from API:', response.country);
        }
        console.log('Banks set:', response.data);
      }
    } catch (error) {
      message.error('Failed to load payment methods');
      console.error('Error fetching payment methods:', error);
    } finally {
      setLoading(false);
    }
  };

  const handleBankSelect = (bankCode) => {
    const selectedBankData = banks.find(bank => bank.code === bankCode);
    console.log('Selected bank data:', selectedBankData);
    console.log('Current country state:', country);
    
    // Pass both bank data and country to parent component
    const bankWithCountry = { ...selectedBankData, country };
    console.log('Sending to parent:', bankWithCountry);
    onBankSelect(bankWithCountry);
  };

  if (loading) {
    return (
      <div className={classes.container}>
        <div className={classes.loading}>
          <Spin size="large" />
          <p>Loading payment methods...</p>
        </div>
      </div>
    );
  }

  return (
    <div className={classes.container}>
      <h4 className={classes.title}>Choose your bank:</h4>
      
      <div className={classes.bankGrid}>
        {banks.map((bank) => (
          <div
            key={bank.code}
            className={`${classes.bankOption} ${
              selectedBank?.code === bank.code ? classes.selected : ''
            }`}
            onClick={() => handleBankSelect(bank.code)}
          >
            <div className={classes.bankLogo}>
              {bank.logoUrl ? (
                <img src={bank.logoUrl} alt={bank.name} />
              ) : (
                <div className={classes.bankName}>{bank.name}</div>
              )}
            </div>
            <div className={classes.bankInfo}>
              <div className={classes.bankName}>{bank.name}</div>
              <div className={classes.bankCurrencies}>
                {bank.supportedCurrencies?.join(', ')}
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default BankSelection; 